module.exports = __webpack_public_path__ + "img/img32.ce72a1be.svg";